import React from 'react';
import styled from '@emotion/styled';
import { FiGithub, FiMail } from 'react-icons/fi';
import { IconType } from 'react-icons';

const Icon = ({ icon: IconComponent, size }: { icon: IconType; size: number }) => (
  <span style={{ display: 'flex', alignItems: 'center' }}>
    {IconComponent({ size })}
  </span>
);

const FooterWrapper = styled.footer`
  padding: 3rem 2.5rem;
  border-top: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1100px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    padding: 2rem 1.25rem;
  }
`;

const Copyright = styled.span`
  font-family: var(--font-mono);
  font-size: 0.7rem;
  color: var(--text-muted);
  letter-spacing: 0.03em;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1.25rem;

  a {
    color: var(--text-muted);
    transition: color 0.2s ease, transform 0.2s ease;
    display: flex;

    &:hover {
      color: var(--accent);
      transform: translateY(-1px);
    }
  }
`;

const Footer: React.FC = () => (
  <FooterWrapper>
    <Copyright>&copy; {new Date().getFullYear()} Aaron Leslie</Copyright>
    <SocialLinks>
      <a href="https://github.com/AaronLeslie138" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
        <Icon icon={FiGithub} size={16} />
      </a>
      <a href="mailto:aaronleslie138@gmail.com" aria-label="Email">
        <Icon icon={FiMail} size={16} />
      </a>
    </SocialLinks>
  </FooterWrapper>
);

export default Footer;
